import gql from 'graphql-tag';

export default gql`
  query getShop($id: Int!) {
    getShop(id: $id) {
      id
      name
      type
      place {
        id
        name
      }
      slug
      socialNetworks {
        id
        name
        url
        image
      }
      category_id
      ttPhone
      ttHours
      ttAllDays
      updated_at
      importantDesk
      importantMob
      headerDesk
      headerMob
      logo1Desk
      logo1Mob
      logo2Desk
      logo2Mob
      logo1Mob
      imgDesk
      imgMob
      details {
        id
        title
        language_id
        content
        ctaLabel
        ctaUrl
        importantTexte
        importantCtaLabel
        importantCtaUrl
        ttTexte
        ttCtaLabel
        ttCtaUrl
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
      }
      blocks
      is_new
      is_heart
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/shop/get.js